import { render, staticRenderFns } from "./editFirm.vue?vue&type=template&id=08c48371&scoped=true"
import script from "./editFirm.vue?vue&type=script&lang=ts"
export * from "./editFirm.vue?vue&type=script&lang=ts"
import style0 from "./editFirm.vue?vue&type=style&index=0&id=08c48371&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c48371",
  null
  
)

export default component.exports